import { Component, OnInit } from '@angular/core';
import { OcInfraModule, OptionParams, ResourceService } from '@diaas/ux-web';
import { CommonService } from '../../services/common.service';
import { AdvGrowlService } from 'primeng-advanced-growl';

@Component({
  selector: 'app-loans-table',
  templateUrl: './loans-table.component.html',
  styleUrls: ['./loans-table.component.scss']
})
export class LoansTableComponent implements OnInit {
  productType: any;

  constructor(public commonService: CommonService) { }
  resourceService: any;
  policyDetails: any;

  tableData: any[] = [];
  columnDefs: { columnDef: string; header: string }[] = [];
  
  // For Tradition policy the column will be 
  _TraditionalPolicies_ColumnHeader = [
    { columnDef: 'loan_date', header: 'Loan Date' },
    { columnDef: 'repaid_date', header: 'Repaid Date' },
    { columnDef: 'original_amount', header: 'Original Amount' },
    { columnDef: 'remaining_amount', header: 'Remaining Amount' },
    { columnDef: 'file_code', header: 'File Code' },
    { columnDef: 'reason_code', header: 'Reason Code' }
  ];

  // For Universal policy the column will be 
  _UniversalPolicies_ColumnHeader = [
    { columnDef: 'remaining_amount', header: 'Remaining Amount' },
    { columnDef: 'original_amount', header: 'Original Amount' },
    { columnDef: 'loan_date', header: 'Initiation Date' },
    { columnDef: 'repaid_date', header: 'Date Repaid' },
    { columnDef: 'reason_code', header: 'Reason' },
    { columnDef: 'preferredLoanInd', header: 'Preferred Loan' },
    { columnDef: 'file_code', header: 'File Code' }
  ];

  ngOnInit() {
    this.resourceService = OcInfraModule.AppInjector.get(ResourceService);
    this.policyDetails = this.resourceService.getResourceFromAliasName('policyDetails');
    this.productType = this.policyDetails.response.product_type;

    var loanindexdetails = OcInfraModule.AppInjector.get(CommonService).getAllUrlOfPolicyDetails();
    if (loanindexdetails["/loans/loanindexdetails"] && loanindexdetails["/loans/loanindexdetails"].href) {
      let url = loanindexdetails["/loans/loanindexdetails"].href;
      let optionParams = new OptionParams();
      optionParams.alias = "loans";
      optionParams.headers = OcInfraModule.AppInjector.get(CommonService).getHeaderByAliasName("loans");

      const user_role = this.commonService.userRole && this.commonService.userRole.toUpperCase() || '';
      const role_name = OcInfraModule.AppInjector.get(CommonService).selectedRole || '';
      const wma_user = window.sessionStorage.getItem('username') || '';

      // Update the headers
      optionParams.headers = {
        ...optionParams.headers,
        user_role: user_role,
        role_name: role_name,
        wma_user: wma_user
      };

      this.invokeLoanIndexDetailsAPI(url, optionParams.headers);
    }
  }


  // Call loan index details API
  invokeLoanIndexDetailsAPI(url, optionParams) {
    this.commonService.getCallback(url, optionParams).subscribe((response) => {
      if (response && response._links && response._links.item) {
        let rawData = response._links.item;
        const isTraditional = this.commonService._T1_WHOLE_LIFE.includes(this.productType);
        this.tableData = this.extractData(rawData, isTraditional);
        this.columnDefs = isTraditional
          ? this._TraditionalPolicies_ColumnHeader
          : this._UniversalPolicies_ColumnHeader;
      }
    }, (error) => {
      OcInfraModule.AppInjector.get(AdvGrowlService).createTimedErrorMessage("Something went wrong, please try again", 'Error', 0);
    });
  }

  extractData(rawData: any[], isTraditional: boolean): any[] {
    if (!rawData && rawData.length) return [];

    return rawData.map((entry: any) => {
      const item = entry.summary;

      // Common fields
      const baseData: any = {
        file_code: item.file_code != null ? item.file_code : '-',
        loan_date: item.loan_date != null ? item.loan_date : '-',
        repaid_date: item.repaid_date != null ? item.repaid_date : '-',
        original_amount: item.original_amount != null ? item.original_amount : '-',
        remaining_amount: item.remaining_amount != null ? item.remaining_amount : '-',
        reason_code: item.reason_code != null ? item.reason_code : '-',
        segment_id: item.segment_id != null ? item.segment_id : '-',
        seq_number: item.seq_number != null ? item.seq_number :  '-'
      };

      if (!isTraditional) {
        baseData['preferredLoanInd'] = item.preferredLoanInd;  // only for Universal
      }

      return baseData;
    });
  }


  // Life Policies Row DoubleClick Row Click
  onLifePoliciesRowDoubleClick($event){
      this.commonService.loanDetailClickedData = $event;
      document.getElementById('loan-values-open-loan-details-anchor').click();
  }


}
